/* Manchester · 2026-05-15 — Carousel-slider fix

   Bug 1: Symmetry's CarouselSlider.handleNavClick (main.js:3560) uses
   `evt.target.matches('.slider-nav__btn')` which is FALSE when the click
   bubbles from the SVG or hidden-text SPAN inside the button. Result:
   prev/next arrows render but clicking them does nothing.

   Bug 2: Many carousels never get initialized because initLazyScript
   waits for them to enter viewport, but on mobile the user may swipe
   horizontally past them before vertical scroll triggers the observer.

   Fix:
   - Delegate click on .slider-nav for all carousel-slider descendants,
     using closest() so SVG/SPAN clicks promote to the button.
   - Force-initialize any visible carousel that hasn't loaded yet.
*/
(function () {
  'use strict';

  function getCarouselForButton(btn) {
    return btn.closest('carousel-slider');
  }

  function getSlideSpan(carousel) {
    if (typeof carousel.slideSpan === 'number') return carousel.slideSpan;
    var slides = carousel.querySelectorAll('.slider__item:not([hidden])');
    if (slides.length < 2) return 0;
    var a = slides[0].getBoundingClientRect().left;
    var b = slides[1].getBoundingClientRect().left;
    return b - a;
  }

  function scrollCarousel(carousel, direction) {
    var slider = carousel.querySelector('.slider');
    if (!slider) return false;
    var slideSpan = getSlideSpan(carousel);
    if (!slideSpan) return false;
    // Manchester · 2026-05-15 — avanzar UNA PAGINA completa por click (no 1 slide).
    // El user reportaba "solo se ven 4 skus" porque slidesToScroll=1 requería
    // muchos clicks. Avanzar slidesPerPage permite recorrer el carrusel rápido.
    var slidesToScroll = carousel.slidesPerPage || carousel.slidesToScroll || 1;
    var delta = slideSpan * slidesToScroll * direction;
    var rtl = document.dir === 'rtl';
    var targetLeft = slider.scrollLeft + (rtl ? -delta : delta);

    // Manchester · 2026-05-15 — scroll-snap-type:mandatory en .slider--edge-peek
    // bloquea scrollTo() programmatic. Temporalmente desactivamos snap y smooth,
    // hacemos el scroll, luego restauramos para preservar el snap natural del swipe.
    var prevSnap = slider.style.scrollSnapType;
    var prevBehavior = slider.style.scrollBehavior;
    slider.style.scrollSnapType = 'none';
    slider.style.scrollBehavior = 'auto';

    slider.scrollLeft = targetLeft;

    // Animate smoothly via JS frame loop since native smooth + snap conflicts
    var startLeft = slider.scrollLeft;
    var endLeft = targetLeft;
    var duration = 350;
    var startTime = performance.now();
    slider.scrollLeft = startLeft;
    function step(now) {
      var t = Math.min(1, (now - startTime) / duration);
      // ease-out cubic
      var eased = 1 - Math.pow(1 - t, 3);
      slider.scrollLeft = startLeft + (endLeft - startLeft) * eased;
      if (t < 1) {
        requestAnimationFrame(step);
      } else {
        // Restore original snap settings
        slider.style.scrollSnapType = prevSnap;
        slider.style.scrollBehavior = prevBehavior;
        // Manchester · 2026-05-15 — update prev/next button enabled state.
        // Symmetry's handleScroll (debounced 100ms) maneja esto via scroll
        // event listener, pero por si acaso forzamos también después del
        // scroll programmatic para que prev/next se desactiven en límites.
        if (typeof carousel.setButtonStates === 'function') {
          try { carousel.setButtonStates(); } catch (e) {}
        }
      }
    }
    requestAnimationFrame(step);
    return true;
  }

  // Delegate click on any slider-nav button — promote target to button via closest()
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('.slider-nav__btn');
    if (!btn) return;
    var carousel = getCarouselForButton(btn);
    if (!carousel) return;

    // Ensure the carousel is initialized — if not, force init
    if (!carousel.hasAttribute('loaded') && typeof carousel.init === 'function') {
      try { carousel.init(); } catch (e) { /* silent */ }
    }

    // If the native handler didn't already scroll (because it returned early
    // when target wasn't .slider-nav__btn), do it ourselves.
    // Detect by waiting a tick and seeing if the slider scrolled. If not, fire.
    var slider = carousel.querySelector('.slider');
    if (!slider) return;
    var scrollBefore = slider.scrollLeft;
    setTimeout(function () {
      var scrollChanged = slider.scrollLeft !== scrollBefore;
      if (!scrollChanged) {
        var direction = btn.getAttribute('name') === 'next'
          ? (document.dir === 'rtl' ? -1 : 1)
          : (document.dir === 'rtl' ? 1 : -1);
        scrollCarousel(carousel, direction);
      }
      // Force setButtonStates even if native handler scrolled — Symmetry's
      // debounced handleScroll listener can miss updates when scroll-snap
      // mandatory + smooth race with our rAF animation.
      setTimeout(function () {
        if (typeof carousel.setButtonStates === 'function') {
          try { carousel.setButtonStates(); } catch (e) {}
        }
      }, 500);
    }, 60);
  }, { passive: true });

  // Force-init any visible carousels that haven't initialized
  function forceInitVisible() {
    document.querySelectorAll('carousel-slider:not([loaded])').forEach(function (c) {
      var rect = c.getBoundingClientRect();
      if (rect.top < window.innerHeight + 200 && rect.bottom > -200
          && typeof c.init === 'function') {
        try { c.init(); } catch (e) {}
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceInitVisible);
  } else {
    forceInitVisible();
  }
  // Re-run on scroll (debounced) so deferred sections get inited as they enter view
  var scrollTimer = null;
  window.addEventListener('scroll', function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(forceInitVisible, 100);
  }, { passive: true });
})();
